const publicDocumentApi = (id, documentId, viewType) => {
  return `/public/share/document-contents/?id=${id}&document_id=${documentId}&view_type=${viewType}`;
};
const publicOutputsApi = (
  id,
  promptId,
  singlePassExtractMode,
  docId,
  profile
) => {
  let url = `/public/share/outputs-metadata/?id=${id}`;
  if (promptId) {
    url += `&prompt_id=${promptId}`;
  }
  if (singlePassExtractMode) {
    url += `&is_single_pass_extract=${singlePassExtractMode}`;
  }
  if (docId) {
    url += `&document_manager=${docId}`;
  }
  if (profile) {
    url += `&profile_manager=${profile}`;
  }
  return url;
};
const publicAdapterApi = (id, adapterType) => {
  return `/public/share/adapter-metadata/?id=${id}&adapter_type=${adapterType}`;
};
const shareManagerToolSource = (id, orgId) => {
  return `/api/v1/unstract/${orgId}/share-manager/tool-source/?tool_id=${id}`;
};
const publicIndexApi = (id, profileId) => {
  return `/public/share/index-metadata/?id=${id}&profile_id=${profileId}`;
};
const publicDefaultOutputApi = (id, documentId) => {
  return `/public/share/default-output-metadata/?id=${id}&document_id=${documentId}`;
};
export {
  publicDocumentApi,
  publicOutputsApi,
  publicAdapterApi,
  shareManagerToolSource,
  publicIndexApi,
  publicDefaultOutputApi,
};
